import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction, Subject, Vehicle} from "domain-models"
import React from "react"
import {hideAuction} from "redux/actions"
import {store} from "store"
import Common from "./Data/Common"
import Contact from "./Data/Contact"
import Engine from "./Data/Engine"
import Environment from "./Data/Environment"
import Identification from "./Data/Identification"
import VehicleDetails from "./Data/VehicleDetails"
import VehicleOptics from "./Data/VehicleOptics"
import NavigationButtons from "./NavigationButtons"
import WatchButton from "../WatchButton"
import {connect} from "react-redux"
import {GlobalState} from "../../../../state"
import _ from "lodash"

type AuctionDataProps = {
  showDetails: boolean
  toggleDetails: () => void
  auction: Auction
  domain: string
}

type State = {
  vehicle: Vehicle
}

class Data extends React.Component<AuctionDataProps, State> {
  constructor(props: AuctionDataProps) {
    super(props)

    this.state = {
      vehicle: _.first(props.auction.subjects)?.vehicle as Vehicle || _.first(props.auction.subjects)?.leading || _.first(props.auction.subjects)?.leasing
    }
  }

  hideAuction = () => {
    store.dispatch(hideAuction())
  }

  render() {
    const auction = this.props.auction
    const vehicle = this.state.vehicle
    return (
      <div className='w-full h-full flex flex-col'>
        <div className="flex flex-row justify-between p-2 shadow">
          <div>
            <button onClick={this.hideAuction}><Icon icon='arrow-left'/> Zurück</button>
          </div>
          <div className="flex justify-end">
            <NavigationButtons showDetails={this.props.showDetails} toggleDetails={this.props.toggleDetails}/>
            <span className="p-1"/>
            <WatchButton auction={auction}/>
          </div>
        </div>

        <div className="w-full h-full overflow-scroll scrollbar p-2">
          <div>
            <Contact dealer={vehicle.dealer}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <Identification vehicle={vehicle}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <Common vehicle={vehicle}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <VehicleDetails vehicle={vehicle}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <Engine vehicle={vehicle}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <VehicleOptics vehicle={vehicle}/>
          </div>
          <div className="border-t border-gray-300 my-4"/>

          <div className="mt-6">
            <Environment vehicle={vehicle}/>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  domain: state.user.domain
}))(Data)
